import { render, staticRenderFns } from "./CoinFeed.vue?vue&type=template&id=83a821e2&scoped=true&"
import script from "./CoinFeed.vue?vue&type=script&lang=ts&"
export * from "./CoinFeed.vue?vue&type=script&lang=ts&"
import style0 from "./CoinFeed.vue?vue&type=style&index=0&id=83a821e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a821e2",
  null
  
)

export default component.exports